@if (languages().length) {
  <div
    class="flex flex-row items-center justify-center gap-6"
    data-testid="kiosk-language-flags"
  >
    @for (language of languages(); track language.locale) {
      <app-kiosk-language-flag-atom
        [languageFlagUrl]="language.flagUrl ?? ''"
        (click)="onChangeLanguage(language.locale, $event)"
      ></app-kiosk-language-flag-atom>
    }
  </div>
}
